import React from "react"
import ContentLoader from "react-content-loader"
import { themeColors } from "../../helpers/themeColors"

const colors = themeColors()

const RatesTableSk = (props) => (
  <ContentLoader 
    speed={2}
    width={props.width || "100%"}
    height={props.height || "100%"}
    viewBox="0 0 710 757"
    backgroundColor="#FFFFFF"
    foregroundColor={colors.darkGray}
    {...props}
  >
    <path d="M 3 35 h 61 v 14 H 3 z M 3 117 h 124 v 22 H 3 z M 3 224 h 124 v 22 H 3 z M 3 331 h 124 v 22 H 3 z M 3 438 h 124 v 22 H 3 z M 3 688 h 124 v 22 H 3 z M 217 117 h 132 v 22 H 217 z M 217 224 h 132 v 22 H 217 z M 217 331 h 132 v 22 H 217 z M 217 438 h 132 v 22 H 217 z M 217 498 h 132 v 22 H 217 z M 562 498 h 57 v 22 h -57 z M 562 533 h 57 v 22 h -57 z M 562 568 h 57 v 22 h -57 z M 562 599 h 57 v 22 h -57 z M 217 533 h 132 v 22 H 217 z M 217 568 h 132 v 22 H 217 z M 217 603 h 132 v 22 H 217 z M 217 688 h 132 v 22 H 217 z M 471 93 h 148 v 59 H 471 z M 471 201 h 148 v 59 H 471 z M 471 308 h 148 v 59 H 471 z M 471 415 h 148 v 59 H 471 z M 471 665 h 148 v 59 H 471 z M 661 111 h 24 v 19 h -24 z M 661 221 h 24 v 19 h -24 z M 661 328 h 24 v 19 h -24 z M 661 435 h 24 v 19 h -24 z M 661 685 h 24 v 19 h -24 z M 217 35 h 61 v 14 h -61 z M 471 35 h 176 v 14 H 471 z" /> 
    <path d="M 0 176.5 h 710 M 0 283.5 h 710 M 0 390.5 h 710 M 0 640.5 h 710 M 0 754.5 h 710" />
  </ContentLoader>
)

export default RatesTableSk